'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var commonColors = {
  inherit: 'inherit'
};
// TODO: use relative x-indices
var commonZIndices = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070
};
var commonBorderStyles = {
  none: 'none',
  solid: 'solid'
};
var commonPrimitives = {
  borderStyles: commonBorderStyles,
  zIndices: commonZIndices,
  // TODO: remove, legacy + typo
  /**
   * @deprecated
   */
  globalPaddingHoriozontal: '16px',
  /**
   * @deprecated
   */
  bottomBarHeight: '48px'
};

exports.commonBorderStyles = commonBorderStyles;
exports.commonColors = commonColors;
exports.commonPrimitives = commonPrimitives;
exports.commonZIndices = commonZIndices;
//# sourceMappingURL=commonPrimitives.js.map
